import styled from 'styled-components'

interface StyledBadgeProps {
  $color: string
}

export const StyledBadge = styled.span<StyledBadgeProps>`
  border-radius: 5px;
  height: 10px;
  width: 10px;
  min-width: 10px;
  background-color: ${({ $color }) => $color};
`
